module.exports = __webpack_public_path__ + "img/ic_yccf.e14c7399.png";